export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6840.22200958.jpg";